export const educationData = [
    {
        id: 1,
        institution: 'Savitribai Phule Pune University | Pune',
        course: 'Master of Computer Application (MCA)',
        startYear: '2021',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Devi Ahilya Vishwavidyalaya | Indore',
        course: 'Bachelor of Computer Science (B.Sc.)',
        startYear: '2018',
        endYear: '2021'
    },
    
]